import { createStorefrontApiClient } from '@shopify/storefront-api-client';

export const storefront = createStorefrontApiClient({
  storeDomain: window.Shopify.shop,
  apiVersion: '2026-01',
  publicAccessToken: window.storefrontAccessToken.personalisation
});
